export const GET_TIMELINE_DETAIL = 'get-timeline-detail'
export const GET_COMMENT_LIST = 'get-comment-list'
export const GET_SUBCOMMENT_LIST = 'get-subcomment-list'
export const ADD_COMMENT = 'add-comment'
export const DELETE_COMMENT = 'delete-comment'
export const ADD_SUB_COMMENT = 'add-sub-comment'
export const GET_ONLY_COMMENT = 'get-only-comment'
export const DELETE_SUB_COMMENT = 'delete-sub-comment'
